module.exports = __webpack_public_path__ + "static/media/dummy450x450.6d81db68.jpg";